import { SafePromise, safeMap } from '@benzinga/safe-await';
import { LineItemPrice, UserSubscription } from './entities';
import {
  ingestSubscription as ingestSubscriptionOG,
  ingestSubscriptions as ingestSubscriptionsOG,
  IngressSubscription,
} from './auth-ingress';

export type { IngressSubscription } from './auth-ingress';

export interface IngressLineItemPrice {
  base_amount: number;
  feature_amount: number;
  immediate_amount: number;
  total_amount: number;
  redirect_to: string;
}

export const ingestLineItemPrice = async (
  incomingLineItemPrice: SafePromise<IngressLineItemPrice>,
): SafePromise<LineItemPrice> =>
  safeMap(incomingLineItemPrice, subscription => ({
    baseAmount: subscription.base_amount,
    featureAmount: subscription.feature_amount,
    immediateAmount: subscription.immediate_amount,
    redirectTo: subscription.redirect_to,
    totalAmount: subscription.total_amount,
  }));

export const ingestSubscription = async (
  incomingSubscription: SafePromise<IngressSubscription>,
): SafePromise<UserSubscription> => {
  return safeMap(incomingSubscription, subscription => ingestSubscriptionOG(subscription));
};

export const ingestSubscriptions = async (
  incomingSubscription: SafePromise<IngressSubscription[]>,
): SafePromise<UserSubscription[]> => {
  return safeMap(incomingSubscription, subscription => ingestSubscriptionsOG(subscription));
};
